import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    quotes: [],
    currentQuote: null,
};

const quoteSlice = createSlice({
    name: "quote",
    initialState,
    reducers: {
        getQuotes() {},
        setQuotes(state, action) { state.quotes = action.payload; },
        getQuote() {},
        setCurrentQuote(state, action) { state.currentQuote = action.payload; },
        clearQuote(state) { state.currentQuote = null; },
        createQuote() {},
        updateQuote() {},
        setQuoteStatus(state, action) {
            if (state.currentQuote) {
                state.currentQuote = { ...state.currentQuote, status: action.payload.status };
            }
        },
        approveQuote() {},
        rejectQuote() {},
        acceptQuote() {},
        declineQuote() {},
        previewQuotePdf() {},
        reopenQuote() {},
        cloneQuote() {},
        setCurrentQuoteComments(state, action) {
            const { quoteId, comments } = action.payload;
            if (state.currentQuote && state.currentQuote._id === quoteId) {
                state.currentQuote = { ...state.currentQuote, comments };
            }
        },
    }
});

export const {
    getQuotes, setQuotes,
    getQuote, setCurrentQuote, clearQuote,
    createQuote, updateQuote, setQuoteStatus,
    approveQuote, rejectQuote,
    acceptQuote, declineQuote,
    previewQuotePdf,
    reopenQuote, cloneQuote, setCurrentQuoteComments
} = quoteSlice.actions;

export default quoteSlice.reducer;
